import React from "react"
import lo from '../pexels-tirachard-kumtanom-347141.jpg'

export default function Header(){
    return(
        <div className="col" id="head">
            <h1>
                The Traveller
            </h1>
            <h3>
                Hello there, Travel guide will help you know where you really want to go to and also what to expect when you get there, the percs and also the scary of wherever you desire
            </h3>
        </div>
    )
}